<template>
	<!-- 商铺写字楼 -->
	
	<div class="shopsOffices-house-container publicCard">
		<div class="search-container">
			<div class="searchLeftbox">
				<div :class="['searchLeftbox-item', (searchItem.isTrue == true ? 'searchLeftbox-item-select' : 'searchLeftbox-item-normal')]"
					v-for="(searchItem,searchIndex) in searchHeaderList" 
					:key='searchIndex' 
					@click="searchClick(searchItem.index)">
					{{ searchItem.name }}
				</div>
			</div>
			<Input class="school-container-search" v-model="inputValue" prefix="ios-search" search enter-button="搜索" placeholder="请输入小区名称/区域/学校" @on-enter="getHouseList(1)" @on-search="getHouseList(1)"/><strong></strong>
			
		</div>
		
		<div class="filter-container">
			<!-- 筛选条件 -->
			<JcHouseFilter :filterList="filterModel" :selectFilterIdList='searchList' @on-change="handleFilterChange"></JcHouseFilter>
		</div>
		<div class="contentBox">
			<div class="contentLeft">
				<Tabs type="card" style='margin: 20px 0 0;' @on-click='tabChangeName'>
					<TabPane label="全部房源"></TabPane>
					<TabPane label="嘉房优选"></TabPane>
					<TabPane label="主推"></TabPane>
					<TabPane label="VR"></TabPane>
				</Tabs>
				<!-- 排序条件 -->
				<div style="position: relative;width: 100%;height: 40px; margin: 10px 0;">
					<JcHouseSort class="sort-container" :sortList="sortList" @on-change="handleSortChange"></JcHouseSort>
				</div>
				<div class="list-container">
					<!-- 房源列表 -->
					<JcHouseList v-if='dataList.length >0 ' class="houseList" v-for="(dataItem,dataIndex) in dataList" :key='dataIndex' :showType="3" :dataModel="dataItem"></JcHouseList>
					<Card v-if='dataList.length == 0' :bordered="false">
						<div style="width: 100%;line-height: 100px;min-height:100px;padding: 20px 0;text-align: center;">暂无数据</div>
					</Card>
				</div>
				<Page class="page" :total="dataTotal" show-elevator @on-change="houseListMange"/>
				<Spin fix size="large" v-if="isLoading"></Spin>
			</div>
			<div class="contentRight">
				<img src="../../assets/images/houseRight.png" alt="" class="rightimg"/>
				<div class="clickDiv" @click="qrCode = true"></div>
				<div class="hideBox" v-if="qrCode == true">
					<img src="../../assets/images/houseRightHide.png" alt=""/>
					<div class="closeBtn" @click="qrCode = false"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Card, Page, Input , Tabs , TabPane , Icon , Message , Spin } from 'iview'
import { propsCall } from "@/common/propsCall"
import { request } from "@/common/request"
import JcHouseList from "../../common/jc-house-list/index.vue"
import JcHouseFilter from "../../common/jc-house-filter/index.vue"
import JcHouseSort from "../../common/jc-house-sort/index.vue"
import {returnBusinessTitleListFunc , returnTitleFunc} from "../../common/jc-jsonUtil/publicTotal.js"
import bitTools from '../../common/jc-jsonUtil/bitTools.js'
export default {
	...propsCall({
		name: 'shopsOfficesList-shopsOffices',
		components:{
			Card,
			Page,
			Input,
			Tabs,
			TabPane,
			Icon,
			Spin,
			Message,
			JcHouseList,
			JcHouseFilter,
			JcHouseSort,
		},
		data(){
			return {
				searchHeaderList:[
					{
						name:'租商铺',
						index:0,
						isTrue:false,
						param:'&&resStatus=2&&bizCode=used&&useType=2&&typeCode=rent',
					},
					{
						name:'买商铺',
						index:1,
						isTrue:false,
						param:'&&resStatus=2&&bizCode=used&&useType=2&&typeCode=buy',
					},
					{
						name:'租写字楼',
						index:2,
						isTrue:false,
						param:'&&resStatus=3&&bizCode=used&&useType=2&&typeCode=rent',
					},
					{
						name:'买写字楼',
						index:3,
						isTrue:false,
						param:'&&resStatus=3&&bizCode=used&&useType=2&&typeCode=buy',
					}
				],
				sortList: [
					"综合排序",
					"时间",
					"单价",
					"总价",
					"面积"
				],
				filterModel: {
					"normalFilter":[
						{
							"filterTitle":"区域",
							"filterId":"plateId",
							"condition":[],
						},
						{
							"filterTitle":"用途",
							"filterId":"productType",
							"condition":[],
						},
						{
							"filterTitle":"租金",
							"filterId":"priceBoxId",
							"condition":[
								{
									"title":"不限",
									"min":"",
									"max":"",
									"id":"99"
								},
								{
									"title":"2000元以下",
									"min":"0",
									"max":"2000",
									"id":"1"
								},
								{
									"title":"2000-4000元",
									"min":"2000",
									"max":"4000",
									"id":"2"
								},
								{
									"title":"4000-6000元",
									"min":"4000",
									"max":"6000",
									"id":"3"
								},
								{
									"title":"6000-8000元",
									"min":"6000",
									"max":"8000",
									"id":"4"
								},
								{
									"title":"8000元以上",
									"min":"8000",
									"max":"100000000",
									"id":"5"
								}
							],
						},
						{
							"filterTitle":"面积",
							"filterId":"areaBoxId",
							"condition":[
								{
									"title":"不限",
									"min":"",
									"max":"",
									"id":"99"
								},
								{
									"title":"100平以下",
									"min":"0",
									"max":"100",
									"id":"1"
								},
								{
									"title":"100-300平",
									"min":"100",
									"max":"300",
									"id":"2"
								},
								{
									"title":"300-500平",
									"min":"300",
									"max":"500",
									"id":"3"
								},
								{
									"title":"500-1000平",
									"min":"500",
									"max":"1000",
									"id":"4"
								},
								{
									"title":"1000-2000平",
									"min":"1000",
									"max":"2000",
									"id":"5"
								},
								{
									"title":"2000以上",
									"min":"2000",
									"max":"100000",
									"id":"6"
								}
							],
						},
						{
							"filterTitle":"房龄",
							"filterId":"propertyYear",
							"condition":[
								{
									"title":"不限",
									"id":""
								},
								{
									"title":"两年以下",
									"id":"3"
								},
								{
									"title":"两年到五年",
									"id":"1"
								},
								{
									"title":"五年到十年",
									"id":"2"
								}
							],
						}
					],
					"moreFilter":[
						// {
						// 	"filterTitle":"区域",
						// 	"condition":[
						// 		{
						// 			"title":"中心城区",
						// 			"id":"1"
						// 		},
						// 		{
						// 			"title":"南湖新区",
						// 			"id":"2"
						// 		},
						// 		{
						// 			"title":"南湖新区",
						// 			"id":"2"
						// 		},
						// 		{
						// 			"title":"南湖新区",
						// 			"id":"2"
						// 		},
						// 		{
						// 			"title":"南湖新区",
						// 			"id":"2"
						// 		},
						// 		{
						// 			"title":"南湖新区",
						// 			"id":"2"
						// 		},
						// 		{
						// 			"title":"南湖新区",
						// 			"id":"2"
						// 		}
						// 	],
						// },
						// {
						// 	"filterTitle":"物业用途",
						// 	"condition":[
						// 		{
						// 			"title":"多层",
						// 			"id":"1"
						// 		},
						// 		{
						// 			"title":"小高层",
						// 			"id":"2"
						// 		},
						// 		{
						// 			"title":"高层",
						// 			"id":"3"
						// 		}
						// 	],
						// },
						// {
						// 	"filterTitle":"VR看房",
						// 	"condition":[
						// 		{
						// 			"title":"VR看房",
						// 			"id":"3"
						// 		},
						// 	]
						// }
					],
					"inputSearch":[
						{
							"filterTitle":"楼层",
							"minId":"floorNoLower",
							"maxId":"floorNoUpper",
							"oneTitle":"楼层下限",
							"twoTitle":"楼层上限"
						},
						{
							"filterTitle":"面积",
							"minId":"houseAreaLower",
							"maxId":"houseAreaUpper",
							"oneTitle":"面积下限",
							"twoTitle":"面积上限"
						},
						{
							"filterTitle":"总价",
							"minId":"priceLower",
							"maxId":"priceUpper",
							"oneTitle":"总价下限",
							"twoTitle":"总价上限"
						}
					]
				},
				searchList:{
					priceUpper:'',//价格上限
					priceLower:'',//价格下限
					houseAreaLower:'',//面积上限
					houseAreaUpper:'',//面积下限
					floorMaxId:'',//楼层上限
					floorMaxId:'',//楼层下限
					priceBoxId:'99',
					areaBoxId:'99',
				},
				publicData:{},
				palteList:[],
				searchParmas:'',
				houseFeause:0,
				dataList: [],
				dataTotal:0,
				isLoading:true,
				qrCode:false,
				inputValue:'',
				paramValue:'',
				sortParams:"",
			}	
		},
		mounted(){	
			this.searchClick(0)
			this.tabChangeName(0)
			this.publicData = JSON.parse(sessionStorage.getItem('publicData'))
			this.palteList = []
			this.palteList = JSON.parse(sessionStorage.getItem('businessList'))
			this.palteList.unshift({ "title":"不限", "id":"" })
			this.filterModel.normalFilter[0].condition  = this.palteList
			this.filterModel.normalFilter[1].condition  = []
			this.filterModel.normalFilter[1].condition  = this.publicData.productType.options
			this.filterModel.normalFilter[1].condition.unshift({ "title":"不限", "id":"" })
		},
		methods:{
			searchClick(index){
				for(let i in this.searchHeaderList){
					if(i == index){
						this.searchHeaderList[i].isTrue = true
						this.paramValue = this.searchHeaderList[i].param
					}else{
						this.searchHeaderList[i].isTrue = false
					}
				}
				this.getHouseList(1)
			},
			handleFilterChange(e) {
				
				if(this.searchList.priceBoxId){
					if(this.searchList.priceBoxId == 99){
						this.searchList.priceUpper = this.searchList.priceUpper ? this.searchList.priceUpper :''
						this.searchList.priceLower = this.searchList.priceLower ? this.searchList.priceLower : ''
					}else{
						for(let i in this.filterModel.normalFilter[2].condition){
							if(this.filterModel.normalFilter[2].condition[i].id == this.searchList.priceBoxId){
								this.searchList.priceUpper = this.searchList.priceUpper ? this.searchList.priceUpper : this.filterModel.normalFilter[2].condition[i].max
								this.searchList.priceLower = this.searchList.priceLower ? this.searchList.priceLower : this.filterModel.normalFilter[2].condition[i].min
							}
						}
					}
					
				}
				if(this.searchList.areaBoxId){
					if(this.searchList.areaBoxId == 99){
						this.searchList.houseAreaUpper = this.searchList.houseAreaUpper ? this.searchList.houseAreaUpper : ''
						this.searchList.houseAreaLower = this.searchList.houseAreaLower ? this.searchList.houseAreaLower : ''
					}else{
						for(let i in this.filterModel.normalFilter[3].condition){
							if(this.filterModel.normalFilter[3].condition[i].id == this.searchList.areaBoxId){
								this.searchList.houseAreaUpper = this.searchList.houseAreaUpper ? this.searchList.houseAreaUpper : this.filterModel.normalFilter[3].condition[i].max
								this.searchList.houseAreaLower = this.searchList.houseAreaLower ? this.searchList.houseAreaLower : this.filterModel.normalFilter[3].condition[i].min
							}
						}
					}
					
				}
				
				
				
				this.searchParmas = ''
				
				for(let key  in this.searchList){
				    if(this.searchList[key]){
						this.searchParmas += "&&"+key+"="+this.searchList[key]
					}
				}
				this.getHouseList(1)
			},
			handleSortChange(selectIndex,isDown) {
				let houseAcreageSort = false
				let totalPriceSort = false
				let unitPriceSort = false
				let gmtCreateSort = false
				if(selectIndex == 0){
					houseAcreageSort = false
					totalPriceSort = false
					unitPriceSort = false
					gmtCreateSort = false
				}else if(selectIndex == 1){
					gmtCreateSort = true
				}else if(selectIndex == 2){
					unitPriceSort = true
				}else if(selectIndex == 3){
					totalPriceSort = true
				}else if(selectIndex == 4){
					houseAcreageSort = true
				}
				this.sortParams = ''
				this.sortParams = '&&gmtCreateSort='+gmtCreateSort+'&&unitPriceSort='+unitPriceSort+'&&totalPriceSort='+totalPriceSort+'&&houseAcreageSort='+houseAcreageSort
				this.getHouseList(1)
			},
			handeEnterSearch(e) {
				console.log(e);
			},
			getHouseList(current){
				this.isLoading = true
				let _this = this
				let param = ''
				if(_this.searchParmas){
					param = "?size=10&&current="+current+"&&houseFeature="+_this.houseFeause+_this.paramValue+_this.sortParams+_this.searchParmas+"&&searchKey="+_this.inputValue
				}else{
					param = "?size=10&&current="+current+"&&houseFeature="+_this.houseFeause+_this.paramValue+_this.sortParams+"&&searchKey="+_this.inputValue
				}
				// let param = "?size=10&&current="+current+"&&searchKey="+_this.inputValue+_this.paramValue
				request({
					url:'/api/open/house/find_house_page' + param,
					method:"get",
					success(data){
						if(data.code == "SUCC"){
							for(let i in data.data.records){
								data.data.records[i].tags = []
								if(data.data.records[i].surveyTakePictures){
									data.data.records[i].surveyTakePictures = data.data.records[i].surveyTakePictures ? data.data.records[i].surveyTakePictures.split('[')[1].split(']')[0].split(',') : null
								}else if(data.data.records[i].surveyTakePictures == null){
									data.data.records[i].surveyTakePictures = ['https://oss.jiafangjunyue.com/0000Base/image-app/WechatIMG163.png']
								}
								data.data.records[i].louName = returnBusinessTitleListFunc(data.data.records[i].plateId,data.data.records[i].businessDistrictId)
								data.data.records[i].houseFeatureObj = bitTools.dealHouseFeature(data.data.records[i].houseFeature)
								if(data.data.records[i].houseFeatureObj.DB_HAVE_VR == true){
									data.data.records[i].tags.push('VR看房')
									
								}else if(data.data.records[i].houseFeatureObj.DB_ENTRUST_EXCLUSIVE == true){
									data.data.records[i].tags.push('独家')
								}else if(data.data.records[i].useType){
									data.data.records[i].useTypeName = returnTitleFunc('useType',data.data.records[i].useType)
									data.data.records[i].tags.push(data.data.records[i].useTypeName)
								}
								data.data.records[i].decorationTypeName = returnTitleFunc('decorationType', data.data.records[i].decorationType)
							}
							_this.dataList = data.data.records
							_this.dataTotal = data.data.total
							_this.isLoading = false
						}else{
							_this.isLoading = false
							Message.error(data.msg)
						}
						
					},
					fail(res){
						_this.isLoading = false
						Message.error(res.msg)
					}
				})

			},
			houseListMange(e){
				this.getHouseList(e)
			},
			tabChangeName(name){
				let obj = {}
				if(name == 0){
					obj = {
						DB_HIGH_QUALITY:'',//优质
						DB_URGENT_SALE:'',//急售
						DB_PRIORITY:'',//主推
						DB_HAVE_VR:'',//VR
					}
				}else if(name == 1){
					obj = {
						DB_HIGH_QUALITY:1,//优质
						DB_URGENT_SALE:'',//急售
						DB_PRIORITY:'',//主推
						DB_HAVE_VR:'',//VR
					}
				}else if(name == 2){
					obj = {
						DB_HIGH_QUALITY:'',//优质
						DB_URGENT_SALE:'',//急售
						DB_PRIORITY:1,//主推
						DB_HAVE_VR:'',//VR
					}
				}else if(name == 3){
					obj = {
						DB_HIGH_QUALITY:'',//优质
						DB_URGENT_SALE:'',//急售
						DB_PRIORITY:'',//主推
						DB_HAVE_VR:1,//VR
					}
				}
				this.houseFeause = bitTools.genarateHouseFeature(obj)
				this.getHouseList(1)
				// this.searchClick(name)
			},
		}
	})
}
</script>

<style lang="less" >
	@import './index.less';
	@import '../../my-theme/global.less';
</style>
